<template>
  <div class="notes">
      <div class="heading bg-user-primary text-bg-user-primary">
       <h3 class="mb-0 p-2 d-inline-block">My Notes</h3>
       <span class="aligned" v-show="showingSavedMessage">
        Saved <i class="far fa-check-circle"></i>
        </span>
      </div>
    <textarea
      v-model="text"
      
      placeholder="Keep personal notes here."
      class="text-area"
    ></textarea>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  metaInfo() {
    return { title: 'Notes' }
  },
  data: function () {
    return {
      timeout: null,
      showingSavedMessage: false,
      textSetter: ''
    }
  },
  computed: {
    // ...mapState('notes', ['text']),
    text: {
      get: function () {
        return this.$store.state.notes.text
      },
      set: function (value) {
        this.textSetter = value
        this.setTime()
      },
    }
  },
  methods: {
    ...mapActions({
      updateNotes: 'notes/updateNotes'
    }),
    saveNotes: function () {
      this.updateNotes(this.textSetter).then((r) => this.savedNotification())
    },
    setTime: function () {
      //use this to adjust how long it takes to make an update in the database. The program will wait for a pause in typing.
      clearTimeout(this.timeout)
      this.timeout = setTimeout(this.saveNotes, 1500)
    },
    hideSavedMessage: function () {
      this.showingSavedMessage = false
    },
    savedNotification: function () {
      clearTimeout(this.timeout)
      this.showingSavedMessage = true
      this.timeout = setTimeout(this.hideSavedMessage, 3000)
    },
  },
}
</script>

<style scoped lang="scss">
.aligned {
  position: relative;
  bottom: 3px;
}
.notes::v-deep {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.text-area {
  flex: 1;
  border: none;
  padding: 20px;
  resize: none;
}
</style>
